export const validateEmail = (email) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};

export const validatePassword = (password) => {
  const re = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return re.test(password);
};

export const checkDuplicateUser = (username, email, getUserFromLocal) => {
  const user = getUserFromLocal();
  return user && (user.username === username || user.email === email);
};
